<app-dialog-save title="Сертификат"
  (cancel)="onCancel()"
  (save)="onSubmit()"
  [disableSave]="!form.dirty || form.invalid || showSpinner"
  [saveButtonShowSpinner]="showSpinner">
  <div class="dialog-content">
    <form [formGroup]="form">
      <mat-slide-toggle #toggle class="icon-toggle" formControlName="isCertified">
        <span class="margin-left-8">
          @if (toggle.checked) {
            Трекер сертифицирован
          } @else {
            Трекер не сертифицирован
          }
        </span>
      </mat-slide-toggle>

      @if (toggle.checked) {
        <div class="margin-top-24 width-100-percent">
          @let expirationDate = form.controls['expirationDate'];
          <app-date-field
            formControlName="expirationDate"
            [errorMessage]="expirationDate.touched && expirationDate.hasError('required')
              ? ('message.error.required-field' | translate)
              : null"
            [label]="'date-field.certificate-label' | translate" />
          @if (form.controls['expirationDate'].value) {
            <div class="margin-top-24">
              <app-certificate-expire [certificateExpire]="selectedExpirationDate"></app-certificate-expire>
            </div>
          }
        </div>
      }
    </form>

  </div>

</app-dialog-save>
